export default __webpack_public_path__ + "static/media/varenum_pt.40cdf8da.gif";